export const showElement = (element): void => {
  if (element) {
    element.classList.remove('hidden')
  }
}

export const hideElement = (element): void => {
  if (element) {
    element.classList.add('hidden')
  }
}

export const getStylePropValue = (
  element,
  property: string,
): CSSPropertyRule => {
  return getComputedStyle(element)[property]
}

export const getTemplateContent = template => {
  return template.content.cloneNode(true)
}

export const getTemplateFirstChild = (template): HTMLElement => {
  return template.content.firstElementChild.cloneNode(true)
}

export const setStyleVariable = (variable: string, value: string): void => {
  document.documentElement.style.setProperty(`--gsc-${variable}`, value)
}

export const skipTransition = (element, isForward: boolean): void => {
  if (element) {
    element.classList.toggle('forward-transition', isForward)
  }
}

export const parseHTML = (html: string): Document => {
  return new DOMParser().parseFromString(html, 'text/html')
}

export const replaceNodeChildren = (node, newNode): void => {
  if (newNode && node) {
    node.replaceChildren(...newNode.cloneNode(true).childNodes)
  }
}
